module.exports = __webpack_public_path__ + "static/media/CC-1.a6e58025.png";